import React from 'react'
import styles from "./index.module.scss";


export default function Welcome() {
    const goToNextModule = (moduleName: any) => {
        const url = new URL(window.location.href);
        const hostnameParts = url.hostname.split('.');

        if (hostnameParts.length === 3) {
            hostnameParts.unshift(moduleName);
        } else if (hostnameParts.length === 4) {
            hostnameParts[0] = moduleName;
        } else {
            throw new Error(`Unexpected hostname structure: ${url.hostname}`);
        }

        url.hostname = hostnameParts.join('.');

        // Не сохраняем route, query и hash
        url.pathname = '/';
        url.search = '';
        url.hash = '';

        window.location.href = url.origin;
    }

    return (
        <div className={styles.welcome}>
            <div className={styles.welcome__text}>
                Цей модуль в розробці. Поки що можете спробувати інші наші модулі.
            </div>
            <div className={styles.welcome__list}>
                <div className={styles.welcome__item}>
                    <div className={styles.welcome__item_top}>
                        <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_7181_102347)">
                                <rect x="8.80005" y="4.3999" width="44" height="44" rx="22" fill="#453CFB"/>
                                <path d="M28.0561 16.8645C28.7942 16.7081 29.4344 17.3173 29.4344 18.0789V26.2008C29.4344 26.4313 29.516 26.6536 29.6587 26.8306L35.0456 33.3923C35.5227 33.9727 35.4207 34.8495 34.7642 35.2077C33.3737 35.9734 31.7792 36.4097 30.0869 36.4097C24.6837 36.4097 20.3 31.9845 20.3 26.5301C20.3 21.7755 23.6235 17.8072 28.0561 16.8645Z" fill="white"/>
                                <path d="M32.2221 25.703H39.3992C40.121 25.703 40.7122 25.1102 40.6185 24.3898C40.0394 19.9852 36.5814 16.4944 32.2181 15.9098C31.5044 15.8151 30.9172 16.412 30.9172 17.1406V24.3857C30.9172 25.1143 31.5004 25.703 32.2221 25.703Z" fill="#DAD8FE"/>
                                <path d="M40.5981 27.6789H37.9882H37.9842H34.7953C33.6943 27.6789 33.0867 28.9756 33.7921 29.836L37.2338 34.0225C37.6742 34.5617 38.4613 34.6646 38.9628 34.183C40.3738 32.8328 41.3851 31.0627 41.801 29.0703C41.956 28.3252 41.3525 27.6789 40.5981 27.6789Z" fill="#DAD8FE"/>
                            </g>
                            <defs>
                                <filter id="filter0_d_7181_102347" x="4.86374e-05" y="-9.77516e-05" width="61.6" height="61.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                    <feOffset dy="4.4"/>
                                    <feGaussianBlur stdDeviation="4.4"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0.270588 0 0 0 0 0.235294 0 0 0 0 0.984314 0 0 0 0.2 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7181_102347"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7181_102347" result="shape"/>
                                </filter>
                            </defs>
                        </svg>
                        <div>
                            <div className={styles.welcome__item_name}>COR TASK</div>
                            <div className={styles.welcome__item_disk}>Керування задачами</div>
                        </div>
                    </div>
                    <div className={styles.welcome__item_description}>
                        Створюйте задачі, керуйте проєктами, розподіляйте роботу команди та контролюйте виконання
                    </div>
                    <div className={styles.welcome__item_link} onClick={() => goToNextModule('task-manager')}>
                        Спробувати зараз
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.5 17L14.5 12L9.5 7" stroke="#453CFB" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className={styles.welcome__item}>
                    <div className={styles.welcome__item_top}>
                        <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_7181_102347)">
                                <rect x="8.80005" y="4.3999" width="44" height="44" rx="22" fill="#453CFB"/>
                                <path d="M28.0561 16.8645C28.7942 16.7081 29.4344 17.3173 29.4344 18.0789V26.2008C29.4344 26.4313 29.516 26.6536 29.6587 26.8306L35.0456 33.3923C35.5227 33.9727 35.4207 34.8495 34.7642 35.2077C33.3737 35.9734 31.7792 36.4097 30.0869 36.4097C24.6837 36.4097 20.3 31.9845 20.3 26.5301C20.3 21.7755 23.6235 17.8072 28.0561 16.8645Z" fill="white"/>
                                <path d="M32.2221 25.703H39.3992C40.121 25.703 40.7122 25.1102 40.6185 24.3898C40.0394 19.9852 36.5814 16.4944 32.2181 15.9098C31.5044 15.8151 30.9172 16.412 30.9172 17.1406V24.3857C30.9172 25.1143 31.5004 25.703 32.2221 25.703Z" fill="#DAD8FE"/>
                                <path d="M40.5981 27.6789H37.9882H37.9842H34.7953C33.6943 27.6789 33.0867 28.9756 33.7921 29.836L37.2338 34.0225C37.6742 34.5617 38.4613 34.6646 38.9628 34.183C40.3738 32.8328 41.3851 31.0627 41.801 29.0703C41.956 28.3252 41.3525 27.6789 40.5981 27.6789Z" fill="#DAD8FE"/>
                            </g>
                            <defs>
                                <filter id="filter0_d_7181_102347" x="4.86374e-05" y="-9.77516e-05" width="61.6" height="61.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                    <feOffset dy="4.4"/>
                                    <feGaussianBlur stdDeviation="4.4"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0.270588 0 0 0 0 0.235294 0 0 0 0 0.984314 0 0 0 0.2 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7181_102347"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7181_102347" result="shape"/>
                                </filter>
                            </defs>
                        </svg>
                        <div>
                            <div className={styles.welcome__item_name}>COR ERP</div>
                            <div className={styles.welcome__item_disk}>Керування бізнесом</div>
                        </div>
                    </div>
                    <div className={styles.welcome__item_description}>
                        Контролюйте фінанси, співробітників, склад, автопарк, ресурси та операційні процеси компанії
                    </div>
                    <div className={styles.welcome__item_link} onClick={() => goToNextModule('erp')}>
                        Спробувати зараз
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.5 17L14.5 12L9.5 7" stroke="#453CFB" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className={styles.welcome__item} style={{opacity: 0.3, pointerEvents: "none"}}>
                    <div className={styles.welcome__item_top}>
                        <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_7181_102347)">
                                <rect x="8.80005" y="4.3999" width="44" height="44" rx="22" fill="#453CFB"/>
                                <path d="M28.0561 16.8645C28.7942 16.7081 29.4344 17.3173 29.4344 18.0789V26.2008C29.4344 26.4313 29.516 26.6536 29.6587 26.8306L35.0456 33.3923C35.5227 33.9727 35.4207 34.8495 34.7642 35.2077C33.3737 35.9734 31.7792 36.4097 30.0869 36.4097C24.6837 36.4097 20.3 31.9845 20.3 26.5301C20.3 21.7755 23.6235 17.8072 28.0561 16.8645Z" fill="white"/>
                                <path d="M32.2221 25.703H39.3992C40.121 25.703 40.7122 25.1102 40.6185 24.3898C40.0394 19.9852 36.5814 16.4944 32.2181 15.9098C31.5044 15.8151 30.9172 16.412 30.9172 17.1406V24.3857C30.9172 25.1143 31.5004 25.703 32.2221 25.703Z" fill="#DAD8FE"/>
                                <path d="M40.5981 27.6789H37.9882H37.9842H34.7953C33.6943 27.6789 33.0867 28.9756 33.7921 29.836L37.2338 34.0225C37.6742 34.5617 38.4613 34.6646 38.9628 34.183C40.3738 32.8328 41.3851 31.0627 41.801 29.0703C41.956 28.3252 41.3525 27.6789 40.5981 27.6789Z" fill="#DAD8FE"/>
                            </g>
                            <defs>
                                <filter id="filter0_d_7181_102347" x="4.86374e-05" y="-9.77516e-05" width="61.6" height="61.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                    <feOffset dy="4.4"/>
                                    <feGaussianBlur stdDeviation="4.4"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0.270588 0 0 0 0 0.235294 0 0 0 0 0.984314 0 0 0 0.2 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7181_102347"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7181_102347" result="shape"/>
                                </filter>
                            </defs>
                        </svg>
                        <div>
                            <div className={styles.welcome__item_name}>COR CRM</div>
                            <div className={styles.welcome__item_disk}>Робота з клієнтами</div>
                        </div>
                    </div>
                    <div className={styles.welcome__item_description}>
                        Ведіть базу клієнтів, керуйте угодами, комунікацією та контролюйте весь процес продажів
                    </div>
                    <div className={styles.welcome__item_link} onClick={() => goToNextModule('crm')}>
                        Спробувати зараз
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.5 17L14.5 12L9.5 7" stroke="#453CFB" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    )
}
